import type { EntityList } from "../../state/EntityList.type"
import type { TilePositionXY } from "../../tile_position_xy/TilePositionXY.type"
import toCoord from "../../tile_position_xy/toCoord"
import { byLayerIdDesc } from "../../util/id"
import type { Entity } from "../index"
import type { EntityXYGridMap } from "./EntityXYGridMap.type"

export default function getEntityXYGridMap(ents: EntityList): EntityXYGridMap {
  // console.log('getEntityXYGridMap', ents)
  const map : EntityXYGridMap = new Map<TilePositionXY, Array<Entity>>
  ents.forEach((entity : Entity): void => {
    const xy = toCoord(entity)
    const list = map.get(xy) || []
    list.push(entity)
    list.sort(byLayerIdDesc)
    map.set(xy, list)
  })
  return map
}
